module.exports = __webpack_public_path__ + "img/icn_linkedin_org.e47bee58.svg";